'use client';

import { getIsServerEnv } from '@/shared/modules/environment';
import { getIs64Bit, getUserAgentOperatingSystemDetails } from '@/shared/modules/user-agent';
import { OS_TYPE } from '@/shared/modules/user-agent/constants';

import type { DownloadLinks, SelectAppUrlLinks } from '../types';

export function useSelectDownloadUrl({ downloadAppWin32, downloadAppWin64, downloadAppOSX }: DownloadLinks) {
  return useSelectAppUrl({
    win32: downloadAppWin32,
    win64: downloadAppWin64,
    osx: downloadAppOSX,
  });
}

const useSelectAppUrl = (link: SelectAppUrlLinks) => {
  if (getIsServerEnv()) {
    return '';
  }
  const os = getUserAgentOperatingSystemDetails().name;

  let url;
  switch (os) {
    case OS_TYPE.WINDOWS:
      url = selectLink(link.win32, link.win64);
      break;
    case OS_TYPE.MAC_OS:
      url = link.osx;
      break;
    default:
      url = selectLink(link.win32, link.win64);
  }

  return url;
};

const selectLink = (link32: string, link64: string) => {
  return getIs64Bit() ? link64 : link32;
};
